import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadComponent: () =>
      import('./features/auth/index').then((m) => m.AuthComponent),
  },
  {
    path: 'lobby',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/lobby/lobby').then((m) => m.LobbyComponent),
  },
  {
    // Join link from QR code — handles auth inline, then auto-joins game
    path: 'games/:id/join',
    loadComponent: () =>
      import('./features/join/join').then((m) => m.JoinComponent),
  },
  {
    // Waiting room — where players sit between joining and the host starting
    path: 'games/:id/waiting',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/waiting/waiting').then((m) => m.WaitingComponent),
  },
  {
    // Shared display screen — wraps Godot iframe (TV/kiosk)
    path: 'games/:id/screen',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/game-screen/game-screen').then((m) => m.GameScreenComponent),
  },
  {
    // Phone controller — player actions (roll, pick)
    path: 'games/:id/play',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/controller/controller').then((m) => m.ControllerComponent),
  },
  {
    path: 'games/:id/end',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/game-end/game-end').then((m) => m.GameEndComponent),
  },
  {
    path: '',
    redirectTo: 'lobby',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'lobby',
  },
];
